export enum GACategories {
  askIdaResults = "Ask Ida - Results",
  createTracker = "Ask Ida - Create Tracker"
}

export enum MetricType {
  weight = "weight",
  time = "time"
}
